module.exports = __webpack_public_path__ + "static/media/fixit-mockup.1966f41a.png";